module.exports = __webpack_public_path__ + "img/head3.fb667b95.png";